module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6703/img/templates-homepage/growth-analytics-icon.svg"